import { graphql } from 'react-relay';
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import {
	type fetchPresenceAGGUsersQuery as UsersQuery$data,
	type fetchPresenceAGGUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceAGGUsersQuery.ts';

export const fetchPresenceAGGUsers = (accountIds: string[]) => {
	return queryInterop<UsersQuery$data, UsersQuery$variables>({
		query: graphql`
			query fetchPresenceAGGUsersQuery($accountIds: [ID!]!) {
				users(accountIds: $accountIds) {
					accountId
					name
					picture
					id
				}
			}
		`,
		variables: { accountIds },
		interopApolloAggClient: true,
	}).then(({ data }) => {
		return (
			data?.users
				?.filter((user) => user?.accountId)
				.map((user) => ({
					avatar: user.picture ?? '',
					email: '',
					name: user.name ?? '',
					userId: user.accountId || '',
				})) ?? []
		);
	});
};
